<span matSnackBarLabel id="lengthElement">
    <img src="/icons/{{baseSiteId}}/cart.png" alt="">
    <p>{{requestedItemList.length}}</p> &nbsp;&nbsp;{{'Requested items'}}
</span>
<span matSnackBarActions>
    <button type="button" class="btn-primary" (click)="navigateRequestPage()">
        {{'patientEducation.reviewRequest'|cxTranslate}}
    </button>
</span>
